// extracted by mini-css-extract-plugin
export default {"title":"SubchapterCard_title__3pQPL"};